export const ORDER_CANCEL = {
  contentTab: 'CANCELLED',
  label: 'Commandes annulées',
  filters: [
    {
      label: 'Status de commandes',
      checkedItems: ['CANCELED_BY_SC', 'CANCELED_BY_CUSTOMER'],
      path: 'status',
      staticName: 'orderStatus',
      defaultList: ['CANCELED_BY_SC', 'CANCELED_BY_CUSTOMER'],
    },
    {
      label: 'Types de commandes',
      checkedItems: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
      path: 'type',
      staticName: 'orderTypes',
      defaultList: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
    },
    {
      label: 'Type de contact',
      checkedItems: ['Professionnel', 'Marketplace', 'Particulier'],
      path: 'contact.store.contactType',
      staticName: 'contactType',
      defaultList: ['Professionnel', 'Marketplace', 'Particulier'],
    },
    {
      label: 'Marques',
      checkedItems: [],
      path: 'contact.store.brand',
      staticName: 'brand',
      defaultList: [
        'Casanoov',
        'Cazeboo',
        'Sicaan',
        'LeroyMerlin',
        'Bricoman',
        'Allegro',
        'ePrice',
        'Kaufland',
        'Worten',
        'Bricodepot',
        'Leclerc',
        'Home24',
        'But',
        'ManoMano',
        'Brico',
        'Praxis',
        'Castorama',
        'Hornbach',
        'Amazon',
        'TikTokShop',
      ],
    },
    {
      label: 'Magasins',
      checkedItems: [],
      path: 'contact.store',
      staticName: 'stores',
      defaultList: [],
    },
  ],
  sortOptions: [
    {
      label: 'Date ↓',
      value: {
        createdAt: -1,
      },
    },
    {
      label: 'Date ↑',
      value: {
        createdAt: 1,
      },
    },
  ],
  table: [
    {
      label: 'Référence', //Nom de la colonne
      code: 'REF', //Type de cellule
      props: 'reference', //Path de la value
    },
    {
      label: 'Date de la commande',
      code: 'DATE',
      props: 'createdAt',
    },
    {
      label: "Date d'annulation",
      code: 'DATE',
      props: 'cancelAt',
    },
    {
      label: 'Client',
      code: 'CONTACT',
      props: 'contact',
    },
    {
      label: 'Prix de la commande',
      code: 'PRICE',
      props: 'price',
    },
    {
      label: 'Motif',
      code: 'REASON',
      props: 'orderCancel',
    },
    {
      label: 'Remboursement',
      code: 'PRICE',
      props: 'amountRefunded',
    },
    {
      label: 'Statut de la commande',
      code: 'STATUS',
      props: 'status',
    },
  ],
};
